class CotizacionRequest {

    postCotizarSimulacion = (datosConsulta) => {
        return {
            "datos": {
                "moneda"    : datosConsulta.moneda,
                "monto"     : datosConsulta.monto,
                "plazo"     : datosConsulta.plazo
            }
        }
    }

}

export default CotizacionRequest;